import styled, { css } from "styled-components";

export const LabelField = styled.label`
	display: block;
    float: left;
    margin-top: 5px;
    width: 100%;
    padding-top: 5px;
`;